import React from 'react';
import shopifyLogo from './assets/shopify_logo.png';
import chewyLogo from './assets/chewy_logo.png';
import adidasLogo from './assets/adidas_logo.png';
import jhuLogo from './assets/jhu_logo.png';
import jpmLogo from './assets/jpm_logo.png';

export default function SocialProofLogos(): JSX.Element {
  return (
    <>
      <img className="shopify-logo" alt="shopify logo" src={shopifyLogo} />
      <img className="chewy-logo" alt="chewy logo" src={chewyLogo} />
      <img className="adidas-logo" alt="adidas logo" src={adidasLogo} />
      <img className="jpm-logo" alt="jpm logo" src={jpmLogo} />
      <img className="jhu-logo" alt="jhu logo" src={jhuLogo} />
    </>
  );
}
